const resumeData = [
    {
        resume: 'pdf/Shubham_Gupta_Resume.pdf',
    }
]

export default resumeData;
